import React from 'react';
import { IconBaseProps } from 'react-icons';

import IntegrationIconSvg from './integration.svg?react';

export default function IntegrationIcon({ size, ...props }: IconBaseProps) {
  return <IntegrationIconSvg width={size || 18} height={size || 18} {...props} />;
}